export const EDIT_PROFILE = "EDIT_PROFILE"
export const PROFILE_SUCCESS = "PROFILE_SUCCESS"
export const PROFILE_ERROR = "PROFILE_ERROR"
export const RESET_PROFILE_FLAG = "RESET_PROFILE_FLAG"

// New user profile actions
export const GET_USER_PROFILE_INFO = "GET_USER_PROFILE_INFO"
export const GET_USER_PROFILE_INFO_SUCCESS = "GET_USER_PROFILE_INFO_SUCCESS"
export const GET_USER_PROFILE_INFO_FAIL = "GET_USER_PROFILE_INFO_FAIL"
export const UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE"
export const UPDATE_USER_PROFILE_SUCCESS = "UPDATE_USER_PROFILE_SUCCESS"
export const UPDATE_USER_PROFILE_FAIL = "UPDATE_USER_PROFILE_FAIL"